export const getValidityDate = (dataString: string): string => {
  const [mesStr, anoStr] = dataString.split('/')
  const mes = parseInt(mesStr)
  const ano = parseInt(anoStr)
  const dataAtual = new Date()
  const dia = dataAtual.getDate()
  const data = new Date(ano, mes - 1, dia)
  return data.toISOString()
}
